import React from 'react';
import CoCardFundTransferCard from './components/CoCardFundTransferIndex.jsx';

const CoCardFundTransfer = ({program}) => {
  return (
      <CoCardFundTransferCard program={program} />
  )
}

export default CoCardFundTransfer;
